import { useMutation } from "@tanstack/react-query";
import apiClient from "api/api-client";
import { AxiosResponse } from "axios";
import { FlatApiError } from "types/api";

export const useForgetDevice = () =>
  useMutation<AxiosResponse<null | FlatApiError>, FlatApiError, void>({
    mutationFn: () => apiClient.post("/auth/forget-device"),
  });
